'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const remapDeprecatedColors = (color) => {
  const mapping = {
    lava10: "cream",
    ocean10: "acidWash",
    sun10: "neutral200",
    white: "neutral100"
  };
  return mapping[color] || color;
};
const breakpoints = {
  tablet: 768,
  desktop: 1230
};

exports.breakpoints = breakpoints;
exports.remapDeprecatedColors = remapDeprecatedColors;
//# sourceMappingURL=TestimonialMapping.cjs.js.map
